module.exports = __webpack_public_path__ + "static/media/Streetballcourt_2_t.5b1ac636.jpg";